import { Account, PayExConnection, PayExConnectionSignup } from '../../../types/management-auth';

export enum ActionTypes {
    OpenPayExModal = '[settings/paymentConnections/payex] OPEN_PAYEX_MODAL',
    InitiatePayExConnection = '[settings/paymentConnections/payex] INITIATE_PAYEX_CONNECTION',
    FetchInitiatePayExConnectionResponse = '[settings/paymentConnections/payex] INITIATE_PAYEX_CONNECTION_RESPONSE',
    ClosePayExModal = '[settings/paymentConnections/payex] CLOSE_PAYEX_MODAL',
    OpenPayexForm = '[settings/paymentConnections/payex] OPEN_PAYEX_FORM',
    PayExApiError = '[settings/paymentConnections/payex] PAYEX_API_ERROR',
}

export interface OpenPayExModal {
    type: ActionTypes.OpenPayExModal;
    payload: {
        accountId: string;
        account: Account;
    };
}

export function openPayExModal(accountId: string, account: Account): OpenPayExModal {
    return {
        type: ActionTypes.OpenPayExModal,
        payload: {
            accountId,
            account,
        },
    };
}

export interface ClosePayExModal {
    type: ActionTypes.ClosePayExModal;
    payload: {};
}

export function closePayExModal(): ClosePayExModal {
    return {
        type: ActionTypes.ClosePayExModal,
        payload: {},
    };
}

export interface InitiatePayExConnection {
    type: ActionTypes.InitiatePayExConnection;
    payload: {
        accountId: string;
        data: PayExConnectionSignup;
        formUrl: string;
    };
}

export function initiatePayExConnection(
    accountId: string,
    data: PayExConnectionSignup,
    formUrl: string
): InitiatePayExConnection {
    return {
        type: ActionTypes.InitiatePayExConnection,
        payload: {
            accountId,
            data,
            formUrl,
        },
    };
}

export interface OpenPayexForm {
    type: ActionTypes.OpenPayexForm;
    payload: {};
}

export function openPayexForm(): OpenPayexForm {
    return {
        type: ActionTypes.OpenPayexForm,
        payload: {},
    };
}

export interface FetchInitiatePayExConnectionResponse {
    type: ActionTypes.FetchInitiatePayExConnectionResponse;
    payload: {
        response: PayExConnection;
    };
    meta: {
        cause: InitiatePayExConnection;
    };
}

export interface PayExApiError {
    type: ActionTypes.PayExApiError;
    payload: {};
}

export type Actions =
    | OpenPayExModal
    | ClosePayExModal
    | InitiatePayExConnection
    | FetchInitiatePayExConnectionResponse
    | PayExApiError
    | OpenPayexForm;
